import { render } from "./YukashoukenSettingOtherItem.vue?vue&type=template&id=5de35af2&ts=true"
import script from "./YukashoukenSettingOtherItem.vue?vue&type=script&lang=ts"
export * from "./YukashoukenSettingOtherItem.vue?vue&type=script&lang=ts"

import "./YukashoukenSettingOtherItem.vue?vue&type=style&index=0&id=5de35af2&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__